import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Image from '../Image';
import VerbButton from '../VerbButton';

class OnscreenNudgeModal extends Component {
    static propTypes = {
        title: PropTypes.string,
        body: PropTypes.string,
        imageUrl: PropTypes.string,
        buttonText: PropTypes.string,
        closeModal: PropTypes.func.isRequired
    };

    render() {
        const { title = '', body = '', imageUrl = '', buttonText = '', closeModal } = this.props;
        return (
            <div className={'onscreenNudgeModal'}>
                <div className={'onscreenNudgeModalContent'}>
                    <Image src={imageUrl} alt={title} dimension={{ w: 150, h: 150 }} />
                    <h2>{title}</h2>
                    <div className={'onscreenNudgeModal-body'}>{body}</div>
                </div>
                <div className={'onscreenNudgeModalAction'}>
                    <VerbButton className={'btn-primary'} onClick={closeModal} buttonText={buttonText} />
                </div>
            </div>
        );
    }
}

export default OnscreenNudgeModal;
